import { applyPageGroupKeyToParents } from '@/utilities/routeUtils';

const pageGroupKey = 'page_group_ticketing';

const ticketRoute = [
    {
        path: '/',
        name: 'ticket.access',
        exact: true,
        component: () => import('@/pages/ticketing/Main.vue'),
        meta: {
            auth: true,
            permission: ['ticket.access'],
        },
    },
    {
        path: '/ticket',
        name: 'ticket.access',
        exact: true,
        component: () => import('@/pages/ticket/Main.vue'),
        meta: {
            auth: true,
            permission: ['ticket.access'],
            title : 'All Tickets'
        },
    },
    {
        path: '/ticket/my-ticket',
        name: 'ticket.my-ticket.access',
        exact: true,
        component: () => import('@/pages/ticket/MyTicket.vue'),
        meta: {
            auth: true,
            permission: ['my-ticket.access'],
            title : 'My Tickets'
        },
    },
    {
        path: '/ticket/create',
        name: 'ticket.create ',
        exact: true,
        component: () => import('@/pages/ticket/AddTicket.vue'),
        meta: {
            auth: true,
            permission: ['ticket.create','my-ticket.create'],
        },
    },
    {
        path: '/ticket/:id',
        name: 'ticket.id.access',
        component: () => import('@/pages/ticket/View.vue'),
        meta: {
            auth: true,
            permission: ['ticket.id.access','my-ticket.id.access'],
        },
    },
    {
        path: '/help-center',
        name: 'ticketing.help-center.access',
        exact: true,
        component: () => import('@/pages/end_user_portal/ticketing/HelpCenter.vue'),
        meta: {
            auth: true,
            permission: ['ticketing.help-center.access'],
        },
    },
];

export default applyPageGroupKeyToParents(ticketRoute, { pageGroupKey });
